module.exports = __webpack_public_path__ + "img/header.4a8c3681.png";